import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Tooltip } from '@web-chat-core/ui-kit';
import { DisplayContext, DisplayContextOptions } from 'contexts';
import { isWebinarEnabled } from 'useCase/webinar/webinarStatus';
import { markWebinarSpeakerLayoutManualOptOut } from 'useCase/webinar/useWebinarAutoLayout';
import { STAGE_LAYOUT } from '../../../../consts';
import { ToogleLayoutButton } from './view';

export const ChangeMeetLayoutButton: React.FC = () => {
    const { t } = useTranslation();
    const { stageLayout, setStageLayout } = useContext<DisplayContextOptions>(DisplayContext);

    const handleClick = () => {
        if (stageLayout === STAGE_LAYOUT.GRID) {
            setStageLayout(STAGE_LAYOUT.SPEAKER);
            return;
        }

        if (isWebinarEnabled()) {
            markWebinarSpeakerLayoutManualOptOut();
        }
        setStageLayout(STAGE_LAYOUT.GRID);
    };

    const tooltip = t(stageLayout === STAGE_LAYOUT.GRID ? 'web_call_show_speaker' : 'web_call_show_members');

    return (
        <Tooltip label={tooltip}>
            <ToogleLayoutButton onClick={handleClick}>
                <Icon
                    icon={stageLayout === STAGE_LAYOUT.GRID ? 'icSpeakerView' : 'icGridView'}
                    size={24}
                    colorVariant="bright"
                />
            </ToogleLayoutButton>
        </Tooltip>
    );
};
